import { LcsDateAdapter } from '@lcs/shared/core';
import { LcsDateRangePickerOption } from '@lcs/shared/datepicker';

import { RelativeDateOptions } from 'generated/graphql-types';

export function dateRangePickerOptionsForCallHistory<D>(dateAdapter: LcsDateAdapter<D>): LcsDateRangePickerOption<D>[] {
   const options: LcsDateRangePickerOption<D>[] = [
      {
         id: RelativeDateOptions.Today,
         displayText: 'Today',
         callback: () => {
            return {
               endDate: dateAdapter.today(),
               startDate: dateAdapter.today(),
            };
         },
      },
      {
         id: RelativeDateOptions.OneWeekAgo,
         displayText: 'This Week',
         callback: () => {
            const startOfWeek = dateAdapter.addCalendarDays(
               dateAdapter.today(),
               -(0 + (dateAdapter.getDayOfWeek(dateAdapter.today()) % 7))
            );
            const endOfWeek = dateAdapter.addCalendarDays(startOfWeek, 6);

            return {
               endDate: endOfWeek,
               startDate: startOfWeek,
            };
         },
      },
      {
         id: RelativeDateOptions.OneMonthAgo,
         displayText: 'Last 30 Days',
         callback: () => {
            return {
               endDate: dateAdapter.today(),
               startDate: dateAdapter.addCalendarDays(dateAdapter.today(), -30),
            };
         },
      },
      {
         id: RelativeDateOptions.NinetyDays,
         displayText: 'Last 90 Days',
         callback: () => {
            return {
               endDate: dateAdapter.today(),
               startDate: dateAdapter.addCalendarDays(dateAdapter.today(), -90),
            };
         },
      },
      {
         id: RelativeDateOptions.LastQuarter,
         displayText: 'Last Quarter',
         callback: () => {
            return dateAdapter.lastQuarter();
         },
      },
      {
         id: RelativeDateOptions.ThisQuarter,
         displayText: 'This Quarter',
         callback: () => {
            return dateAdapter.thisQuarter();
         },
      },
      {
         id: RelativeDateOptions.PreviousTwelveMonths,
         displayText: 'Previous 12 Months',
         callback: () => {
            return dateAdapter.previous12Months();
         },
      },
   ];
   return options;
}
